import { render } from "./ReadMoreComponent.vue?vue&type=template&id=bd89cf4c&ts=true"
import script from "./ReadMoreComponent.vue?vue&type=script&lang=ts"
export * from "./ReadMoreComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__